const popup = document.querySelector(".tracking-result.no-result");
const loader = document.querySelector(".loader");
const closeBtn = popup.querySelector(".close-btn");
const popupBox = popup.querySelector(".popup");
const buttonSearch = document.querySelector(".button-search");
const notFoundMessage = popup.querySelector(".not-found-message");
const notSupportMessage = popup.querySelector(".not-support-message");

const inputs = document.querySelectorAll('.input-wrapper .input');

inputs.forEach((input) => {
  const wrapper = input.closest('.input-wrapper');
  const placeholder = wrapper.querySelector('.custom-placeholder');

  const togglePlaceholder = () => {
    if (input.value.trim()) {
      placeholder.style.opacity = '0';
    } else {
      placeholder.style.opacity = '1';
    }
  };

  input.addEventListener('input', togglePlaceholder);
  togglePlaceholder();
});

closeBtn.addEventListener("pointerup", () => {
    popup.classList.add("close");
    popup.classList.remove("open");
});

document.addEventListener("pointerup", (e) => {
if (!popupBox.contains(e.target)) {
    popup.classList.add("close");
    popup.classList.remove("open");
}
});

const apiUrl = "/apps/tra-cuu-don-hang/?v=1";
function getOrder(contact, orderNo) {

    const contactType = 
        document.querySelector('input[name="contact"]').value.trim().includes("@") 
        ? 'email' : 'phone';
    
    const body = contactType === 'email' ? {
        email: contact,
        orderId: orderNo,
    } : {
        phone: contact,
        orderId: orderNo,
    };
    return fetch(apiUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    })
    .then(response => response.json())
    .then(data => {
        return data;
    })
    .catch(error => {
        console.error("Error fetching order:", error);
        throw error;
    });
}

const convertToSlug = (text) => {
  return !!text 
    ? text
      .replace(/\s+/g, '')
      .replace(/^0/, '')
      .replace(/^\+84/, '')
    : "";
}

document.querySelector(".searching-form").addEventListener("submit", async (e) => {
    e.preventDefault();
    loader.style.display = "block";
    buttonSearch.style.pointerEvents = "none";
    buttonSearch.style.backgroundColor = "rgba(112, 192, 40, 0.8)";

    const contact = e.target.querySelector('input[name="contact"]').value.replace(/\s+/g, '');
    const orderNo = e.target.querySelector('input[name="orderNo"]').value.replace(/\s+/g, '');

    try {
        const returnedOrder = await getOrder(contact, orderNo);
        
        const orderPhone = convertToSlug(returnedOrder?.shippingAddress?.phone);
        const inputPhone = convertToSlug(contact);
        
        
        if (!!returnedOrder.error || (!contact.includes("@") && inputPhone !== orderPhone) || (!contact.includes("@") && contact.length < 10)) {
            popup.classList.remove("close");
            popup.classList.add("open");
            notFoundMessage.classList.add("active");
            notSupportMessage.classList.remove("active");
        } else {
            if (returnedOrder?.clickandcollect?.length > 1) {
                popup.classList.remove("close");
                popup.classList.add("open");
                notSupportMessage.classList.add("active");
                notFoundMessage.classList.remove("active");
            } else {
                window.location.href = 
                    `/pages/order-tracking-result?contact=${encodeURIComponent(contact)}&orderNo=${encodeURIComponent(orderNo)}`;
            }
        }

        loader.style.display = "none";
        buttonSearch.style.pointerEvents = "auto";
        buttonSearch.style.backgroundColor = "#70C028";
    } catch (err) {
        console.error("Order fetch failed", err);
    }
});